export const RECEIVED_INSTALLED_APPS = 'site/RECEIVED_INSTALLED_APPS';
export const SET_IS_POPUP = 'site/SET_IS_POPUP';
export const SET_COMPONENT_ID = 'site/SET_COMPONENT_ID';
export const SET_ORIGINAL_COMPONENT_ID = 'site/SET_ORIGINAL_COMPONENT_ID';
export const SET_APP_COMPONENT = 'site/SET_APP_COMPONENT';
export const APP_LOADED = 'site/APP_LOADED';
export const SET_IS_SOCIAL = 'site/SET_IS_SOCIAL';
export const SET_SIGNED_INSTANCE = 'site/SET_SIGNED_INSTANCE';
export const SET_VIEW_MODE = 'view-mode/SET';

export const setIsSocial = (isSocial) => ({
  type: SET_IS_SOCIAL,
  payload: isSocial,
});
export const receivedInstalledApps = (payload) => ({
  type: RECEIVED_INSTALLED_APPS,
  payload,
});
export const setComponentId = (payload) => ({ type: SET_COMPONENT_ID, payload });
export const setOriginalComponentId = (payload) => ({
  type: SET_ORIGINAL_COMPONENT_ID,
  payload,
});
export const setViewMode = (payload) => ({ type: SET_VIEW_MODE, payload });

export const setSignedInstance = (signedInstance) => ({ type: SET_SIGNED_INSTANCE, payload: signedInstance });

const setAppComponent = (appComponent) => ({
  type: SET_APP_COMPONENT,
  payload: appComponent,
});

export const initAppComponent = ({ appComponent }) => (dispatch) => {
  appComponent && dispatch(setAppComponent(appComponent));
};

export const initIsSocial = ({ isSocial }) => (dispatch) => {
  dispatch(setIsSocial(isSocial));
};

export const appLoaded = () => ({ type: APP_LOADED });
